// src/components/img/GalerySectionVessels/VesselIolaos.tsx
import React from 'react';
import vesselImage from './iolaos.jpeg';

const VesselIolaos: React.FC = () => (
  <img src={vesselImage} alt="Vessel Iolaos" />
);

export default VesselIolaos;